export default "__VITE_ASSET__B5tC6u2X__"